import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component, cloneElement } from 'react';
import { getBoxSize, navigateSize } from '../system';
import InputBox from '../Input/InputBox';
import WrapView from '../WrapView';
import { defaultRenderToken, defaultRenderInput } from './default-renders';
import DefaultToken from './DefaultToken';

var TokenInput = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TokenInput, _Component);

  function TokenInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "state", {
      inputValue: ''
    });

    _defineProperty(_assertThisInitialized(_this), "clearInputValue", function () {
      _this.setState({
        inputValue: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addToken", function (token) {
      var newTokens = [].concat(_this.props.tokens);
      var tokenIndex = newTokens.indexOf(token);

      if (tokenIndex > -1) {
        var removed = newTokens.splice(tokenIndex, 1);
        newTokens.push(removed[0]);
      } else {
        newTokens.push(token);
      }

      if (_this.props.onChange) {
        _this.props.onChange({
          token: token,
          tokenIndex: tokenIndex,
          tokens: newTokens,
          added: true
        });
      }

      _this.clearInputValue();
    });

    _defineProperty(_assertThisInitialized(_this), "removeToken", function (token, focusIndex) {
      var newTokens = [].concat(_this.props.tokens);
      var tokenIndex = -1;

      if (token.constructor === Array) {
        token.some(function (val) {
          tokenIndex = newTokens.indexOf(val);

          if (tokenIndex > -1) {
            newTokens.splice(tokenIndex, 1);
            return true;
          }

          return false;
        });
      } else {
        tokenIndex = newTokens.indexOf(token);

        if (tokenIndex > -1) {
          newTokens.splice(tokenIndex, 1);
        }
      }

      if (_this.props.onChange) {
        _this.props.onChange({
          token: token,
          tokenIndex: tokenIndex,
          tokens: newTokens,
          added: false
        });
      }

      if (typeof focusIndex === 'number') {
        setTimeout(function () {
          _this.focus(focusIndex >= newTokens.length ? undefined : focusIndex);
        });
      } else {
        _this.blur();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputKeyDown", function (e) {
      var _e$target = e.target,
          selectionStart = _e$target.selectionStart,
          selectionEnd = _e$target.selectionEnd;
      var canMoveFocusBackward = selectionStart === 0 && selectionEnd === 0;

      if (_this.props.tokens.length > 0 && canMoveFocusBackward && (e.key === 'Backspace' || e.key === 'ArrowLeft')) {
        e.preventDefault();

        _this.focusLastToken();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e) {
      _this.setState({
        inputValue: e.target.value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      _this.inputBox.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function (index) {
      _this.inputBox.focus(index);
    });

    _defineProperty(_assertThisInitialized(_this), "focusFirstToken", function () {
      _this.focus(0);
    });

    _defineProperty(_assertThisInitialized(_this), "focusLastToken", function () {
      _this.focus(_this.props.tokens.length - 1);
    });

    return _this;
  }

  var _proto = TokenInput.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(lastProps) {
    if (lastProps.tokens.length !== this.props.tokens.length) {
      this.clearInputValue();
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onChange = _this$props.onChange,
        renderInput = _this$props.renderInput,
        renderToken = _this$props.renderToken,
        tokens = _this$props.tokens,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["onChange", "renderInput", "renderToken", "tokens"]);

    var inputProps = {
      size: navigateSize(restProps.size, -1),
      stroke: false,
      strokeWeight: 0,
      grow: 1,
      shrink: 1,
      paddingLeft: 0,
      paddingRight: 0,
      paddingVertical: 0,
      onKeyDown: this.handleInputKeyDown,
      onChange: this.handleInputChange,
      value: this.state.inputValue
    };

    var _getBoxSize = getBoxSize(restProps.size),
        paddingVertical = _getBoxSize.paddingVertical;

    return /*#__PURE__*/React.createElement(WrapView, _extends({
      as: InputBox,
      innerRef: function innerRef(c) {
        return _this2.inputBox = c;
      },
      role: "group",
      focusChildIndex: tokens.length,
      evenPadding: true,
      spacing: paddingVertical
    }, restProps), tokens.map(function (token, tokenIndex) {
      var removeToken = _this2.removeToken.bind(_this2, token);

      var selectFirstToken = _this2.focusFirstToken;
      var selectLastToken = _this2.focusLastToken;

      var selectNextToken = _this2.focus.bind(_this2, tokenIndex + 1);

      var selectPreviousToken = _this2.focus.bind(_this2, tokenIndex - 1);

      var tokenToRender = renderToken(token, {
        keyboardControls: {
          tabIndex: 0,
          onKeyDown: function onKeyDown(e) {
            if (e.key === 'Backspace') {
              e.preventDefault();
              removeToken(tokenIndex);
            }

            if (e.key === 'ArrowLeft') {
              e.preventDefault();
              selectPreviousToken();
            }

            if (e.key === 'ArrowRight') {
              e.preventDefault();
              selectNextToken();
            }
          }
        },
        removeToken: removeToken,
        selectFirstToken: selectFirstToken,
        selectLastToken: selectLastToken,
        selectNextToken: selectNextToken,
        selectPreviousToken: selectPreviousToken,
        tokenIndex: tokenIndex
      });
      return typeof tokenToRender === 'string' ? /*#__PURE__*/React.createElement(DefaultToken, {
        key: tokenToRender,
        removeToken: removeToken,
        selectFirstToken: selectFirstToken,
        selectLastToken: selectLastToken,
        selectNextToken: selectNextToken,
        selectPreviousToken: selectPreviousToken,
        token: tokenToRender,
        tokenIndex: tokenIndex
      }) : /*#__PURE__*/cloneElement(tokenToRender, {
        key: JSON.stringify(token)
      });
    }), renderInput(inputProps, {
      clearInputValue: this.clearInputValue,
      addToken: this.addToken,
      removeToken: this.removeToken,
      selectFirstToken: this.focusFirstToken,
      selectLastToken: this.focusLastToken
    }));
  };

  return TokenInput;
}(Component);

_defineProperty(TokenInput, "Token", DefaultToken);

_defineProperty(TokenInput, "defaultProps", {
  tokens: null,
  renderToken: defaultRenderToken,
  renderInput: defaultRenderInput,
  size: 'md'
});

export default TokenInput;